import Simulation from './class/Simulation'
import { wait, throttle } from './common'
import Donut from './class/Donut'

let opt, simu

// titre rouge
const titleSimulation = document.querySelector(
  'body.page-template-simulation section.header h1'
)
if (titleSimulation) {
  const text = titleSimulation.innerText.split(' : ')
  if (text.length === 2) {
    text[1] = `<span style="color: var(--wp--preset--color--red);">${text[1].trim()}</span>`
    titleSimulation.innerHTML = text.join('&nbsp;: ')
  }
}

const formSimulation = document.querySelector(
  'body.page-template-simulation .form-simulation, body.single-tender .form-simulation'
)
if (formSimulation) {
  const simulationReport = document.querySelector('.simulation-report')
  const graphEl = simulationReport.querySelector('.graph .canvas')
  const graphFrais = simulationReport.querySelector('.graph .frais')
  const btnSimuler = formSimulation.querySelector('button')

  opt = Object.assign({}, window.simulationOptions || {})
  opt.dom = {
    form: formSimulation,
    process: formSimulation.querySelector('button'),
    tjm: formSimulation.querySelector('.tjm'),
    jours: formSimulation.querySelector('.jours'),
    frais: formSimulation.querySelector('.frais'),
  }

  simu = new Simulation(opt)
  const colors = [
    'var(--green)',
    'var(--lightgreen)', //#70E0BA
    'var(--darkred)', //#FDACA6
    'var(--red)',
  ]
  const graph = new Donut({ element: graphEl, colors })
  graph.setData([
    simu.var.salaireNet,
    simu.var.frais,
    simu.var.valeurCharges,
    simu.var.valeurFraisGestion,
  ])
  graphFrais.style.display = simu.var.frais === 0 ? 'none' : 'table-row'

  const throttledUpdate = throttle(() => {
    graph.setData([
      simu.var.salaireNet,
      simu.var.frais,
      simu.var.valeurCharges,
      simu.var.valeurFraisGestion,
    ])
    graphFrais.style.display = simu.var.frais === 0 ? 'none' : 'table-row'
  }, 20)
  simu.dom.form.addEventListener('update', throttledUpdate)

  btnSimuler.addEventListener('click', () => {
    simulationReport.classList.add('open')
    btnSimuler.disabled = true
    btnSimuler.style.display = 'none'
  })

  for (const el of document.querySelectorAll('.modal')) {
    // el.addEventListener('input', validate)
    el.querySelector('.process').addEventListener('click', process)
  }
}

function validate(e) {
  const modal = e.target.closest('.modal')
  const inputs = modal.querySelectorAll('input')
  let valid = true
  for (const el of inputs) {
    if (!el.validity.valid) {
      // console.log(el.getAttribute('class'))
      valid = false
      break
    }
  }
  // modal.querySelector('.process').disabled = !valid
}

async function process(e) {
  const btn = e.target.closest('.process')
  const modal = btn.closest('.modal')
  const message = modal.querySelector('.message')
  const inputs = modal.querySelectorAll('input')
  message.innerHTML = ''
  const data = { ...btn.dataset, ...simu.var, ...getValues(inputs) }
  const rgpd = modal.querySelector('.rgpd')
  // console.log(data)

  if (!rgpd.checked) {
    message.innerHTML = 'Votre consentement à la loi RGPD est nécessaire'
    rgpd.focus()
    return
  }

  // start loading
  btn.innerHTML = `<span>${data.loading}<span>${data.loading}</span></span>`
  btn.disabled = true
  await wait(200)

  // send
  let response
  try {
    response = await fetch(data.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: new URLSearchParams(data),
    })
    btn.disabled = false
  } catch (error) {
    btn.disabled = false
    message.innerHTML = 'Pas de réseau disponible'
  }

  // end loading
  btn.innerHTML = `<span>${data.label}<span>${data.label}</span></span>`

  if (!response.ok) {
    message.innerHTML = 'La réponse du serveur est incorrecte.'
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  if (json.data.odoo_error) {
    message.innerHTML =
      "Une erreur est survenue lors de l'appel au serveur de données."
    return
  }

  if (!json.data.response.valid) {
    if (json.data.response.errors?.length > 0) {
      const lines = json.data.response.errors.map((el) => `<div>${el}</div>`)
      message.innerHTML = lines.join('')
    }
  } else {
    if (json.data.message) {
      message.innerHTML = json.data.message
    }

    if (json.data.valid) {
      modal.classList.add('ok')
      resetValues(inputs)
    }
  }
}

function getValues(elements) {
  const output = {}
  for (const el of elements) {
    let value
    switch (el.type || null) {
      case 'radio':
      case 'checkbox':
        value = el.checked ? 1 : 0
        break
      default:
        value = el.value
    }
    output[el.getAttribute('class')] = value
  }
  return output
}

function resetValues(elements) {
  for (const el of elements) {
    switch (el.type || null) {
      case 'radio':
      case 'checkbox':
        el.checked = false
        break
      default:
        el.value = ''
    }
  }
}
